// src/pages/Login.jsx
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  Box, Button, TextField, Typography, Stack, Alert, CircularProgress,
  Paper, InputAdornment, IconButton,
} from "@mui/material";
import AutoStoriesIcon  from "@mui/icons-material/AutoStories";
import VisibilityIcon   from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { login } from "../auth";
import { indigoGradient, C } from "../theme";

export default function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const expired  = new URLSearchParams(location.search).get("expired") === "1";

  const [form,    setForm]    = useState({ username: "", password: "" });
  const [showPwd, setShowPwd] = useState(false);
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await login(form.username, form.password);
      window.dispatchEvent(new Event("auth-changed"));
      navigate("/exams");
    } catch (err) {
      setError(err?.response?.data?.detail || "Identifiants incorrects.");
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: "78vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Box sx={{ width: "100%", maxWidth: 400 }} className="au">
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Box sx={{ width:54, height:54, borderRadius:3, mx:"auto", mb:2, background:indigoGradient, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <AutoStoriesIcon sx={{ color:"white", fontSize:26 }} />
          </Box>
          <Typography variant="h4" fontWeight={700}>Connexion</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt:.5 }}>Accédez à votre espace d'examens</Typography>
        </Box>

        <Paper sx={{ p: 4, borderRadius: "16px" }}>
          {expired && <Alert severity="warning" sx={{ mb:2.5 }}>Session expirée. Veuillez vous reconnecter.</Alert>}
          {error   && <Alert severity="error"   sx={{ mb:2.5 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2.5}>
              <TextField label={t("auth.login.username")} fullWidth required autoFocus
                value={form.username} onChange={e => setForm({...form, username: e.target.value})}
                autoComplete="username" />
              <TextField label={t("auth.login.password")} type={showPwd ? "text" : "password"} fullWidth required
                value={form.password} onChange={e => setForm({...form, password: e.target.value})}
                autoComplete="current-password"
                InputProps={{ endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setShowPwd(v => !v)} edge="end">
                      {showPwd ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                )}} />
              <Button type="submit" variant="contained" size="large" fullWidth disabled={loading} sx={{ py: 1.3, mt: .5 }}>
                {loading ? <CircularProgress size={20} color="inherit" /> : t("auth.login.submit")}
              </Button>
              <Typography variant="body2" sx={{ textAlign:"right", mt:-.5 }}>
                <Link to="/forgot-password"
                  style={{ color: C.indigo[600], fontWeight: 500, textDecoration: "none", fontSize:"0.82rem" }}>
                  Mot de passe oublié ?
                </Link>
              </Typography>
            </Stack>
          </Box>
          <Typography variant="body2" sx={{ mt:2.5, textAlign:"center", color:"text.secondary" }}>
            Pas encore de compte ?{" "}
            <Link to="/register" style={{ color: C.indigo[600], fontWeight: 600, textDecoration: "none" }}>S'inscrire</Link>
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}